import React, { useMemo, useState } from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchControlBar,
  DemoWorkbenchPill,
  DemoWorkbenchSearchInput,
  DemoWorkbenchSelect,
  DemoWorkbenchStack,
} from "@csk/demo-ui";
import {
  DIAGRAM_GALLERY,
  buildDiagramCategoryStats,
  filterDiagrams,
} from "./diagram-gallery-panel/diagramGalleryModel.js";

const CATEGORY_STATS = buildDiagramCategoryStats(DIAGRAM_GALLERY);

const DiagramGalleryPanel = (): React.JSX.Element => {
  const [filter, setFilter] = useState<string>("all");
  const [search, setSearch] = useState("");

  const filtered = useMemo(
    () => filterDiagrams(DIAGRAM_GALLERY, filter, search),
    [filter, search],
  );
  const categoryOptions = useMemo(
    () => [
      { value: "all", label: `All (${DIAGRAM_GALLERY.length})` },
      ...CATEGORY_STATS.categories.map((category) => ({
        value: category,
        label: `${category} (${CATEGORY_STATS.counts.get(category) ?? 0})`,
      })),
    ],
    [],
  );

  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchCard
        title={`Diagram Gallery (${DIAGRAM_GALLERY.length} diagrams)`}
        right={
          <DemoWorkbenchPill>{filtered.length} matching</DemoWorkbenchPill>
        }
      >
        <DemoWorkbenchControlBar>
          <DemoWorkbenchSearchInput
            ariaLabel="Search diagrams"
            placeholder="Search diagrams..."
            value={search}
            onChange={setSearch}
          />
          <DemoWorkbenchSelect
            ariaLabel="Filter diagram category"
            value={filter}
            options={categoryOptions}
            onChange={setFilter}
          />
        </DemoWorkbenchControlBar>
      </DemoWorkbenchCard>

      <DemoWorkbenchStack className="max-h-96 overflow-y-auto" gap={4}>
        {filtered.map((diagram) => (
          <DemoWorkbenchCard
            key={diagram.id}
            compact
            title={diagram.name}
            right={
              <>
                <DemoWorkbenchPill mono>{diagram.id}</DemoWorkbenchPill>
                <DemoWorkbenchPill>{diagram.category}</DemoWorkbenchPill>
              </>
            }
          >
            <DemoWorkbenchCopy>{diagram.location}</DemoWorkbenchCopy>
          </DemoWorkbenchCard>
        ))}
      </DemoWorkbenchStack>
    </DemoWorkbenchStack>
  );
};

export default DiagramGalleryPanel;
